import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

import { UserType } from 'store/modules/auth/auth';
import Forms from 'components/Forms';
import api from 'api';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      padding: theme.spacing(3),
      border: '1px solid #CECECA',
      boxShadow: ' 0 4px 12px 0 rgba(0,0,0,0.1)',
      borderRadius: '10px',
    },
    label: {
      textAlign: 'right',
      fontWeight: 700,
    },
  })
);

const User = (user: UserType) => {
  const classes = useStyles();

  const updateUser = (values: UserType) =>
    api.resources
      .updateOrganizationUser({
        uuid: user.uuid,
        organization_name: user.organizations[0].codename,
        user: values,
      })
      .catch((err) => {
        Forms.helpers.throwError(err.response.data);
      });

  if (!user.uuid) {
    return null;
  }

  return (
    <Grid container justify="center" spacing={3}>
      <Grid item xs={12} sm={10}>
        <Paper className={classes.modal}>
          <Forms.User initialValues={user} onSubmit={updateUser} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default User;
